import { FunctionComponent } from 'react'
import {
  Container,
  Title,
  Subtitle,
  Paragraph,
  Button,
  Image,
  ButtonWrapper,
} from './NoResults.style'

interface NoResultsProps {
  imageSrc?: string
  title?: string
  subtitle?: string
  paragraph?: string | JSX.Element
  imageSize?: 'big' | 'medium'
  buttons?: [
    {
      variant: 'outlined' | 'contained'
      title: string
      onClick?: () => any
    }
  ]
}

const NoResults: FunctionComponent<NoResultsProps> = ({
  imageSrc,
  title,
  subtitle,
  paragraph,
  imageSize = 'big',
  buttons = [],
  ...props
}) => {
  return (
    <Container {...props}>
      {title && <Title variant="h4">{title}</Title>}
      {imageSrc && <Image size={imageSize} src={imageSrc} />}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {paragraph && <Paragraph>{paragraph}</Paragraph>}
      {!!buttons.length && (
        <ButtonWrapper>
          {buttons.map((btn, idx) => (
            <Button
              onClick={btn.onClick}
              color="primary"
              variant={btn.variant}
              key={`no-results-btn-${idx}`}
            >
              {btn.title}
            </Button>
          ))}
        </ButtonWrapper>
      )}
    </Container>
  )
}

export default NoResults
